// Librairies
import React from 'react';
import PropTypes from 'prop-types';

import LoadingIcon from '../../svg/utils/waiting';

// Styles
import s from './loader.module.css';
import t from '../../css/global.module.css';
// Render
const Loader = (props) => {
  const { size, fill, classNameLoader } = props;
  const loader = (
    <div className={classNameLoader}>
      <div
        style={{ width: `${size}rem`, height: `${size}rem` }}
        className={`overflow-hidden ${s.main}`}
      >
        <LoadingIcon fill={fill} />
        <span className={t['sr-only']}>Loading...</span>
      </div>
    </div>
  );
  return loader;
};

Loader.propTypes = {
  size: PropTypes.number,
  fill: PropTypes.string,
  classNameLoader: PropTypes.string,
};

Loader.defaultProps = {
  size: 2.1,
  fill: 'grey',
  classNameLoader: '',
};

export default Loader;
